var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropin-container col-12 col-lg-8 pl-0",attrs:{"id":"dropin-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }